import { useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const TrackNavigation = () => {
  const location = useLocation();

  const getBrowser = (userAgent) => {
    if (userAgent.indexOf('Chrome') > -1) return 'Chrome';
    if (userAgent.indexOf('Firefox') > -1) return 'Firefox';
    if (userAgent.indexOf('Safari') > -1) return 'Safari';
    if (userAgent.indexOf('Edge') > -1) return 'Edge';
    if (userAgent.indexOf('Opera') > -1) return 'Opera';
    return 'Unknown';
  };

  const getOperatingSystem = (userAgent) => {
    if (userAgent.indexOf('Windows NT 10.0') > -1) return 'Windows 10';
    if (userAgent.indexOf('Windows NT 6.3') > -1) return 'Windows 8.1';
    if (userAgent.indexOf('Windows NT 6.2') > -1) return 'Windows 8';
    if (userAgent.indexOf('Windows NT 6.1') > -1) return 'Windows 7';
    if (userAgent.indexOf('Mac OS X') > -1) return 'MacOS';
    if (userAgent.indexOf('Linux') > -1) return 'Linux';
    if (userAgent.indexOf('Android') > -1) return 'Android';
    if (userAgent.indexOf('iOS') > -1) return 'iOS';
    return 'Unknown';
  };

  const logPageNavigation = useCallback(async (toPage) => {
    try {
      console.log('Attempting to log navigation to:', toPage);
      const apiUrl = `${process.env.REACT_APP_BASE_Backend_URL}/clicklogs/logClick`;

      let ipAddress = null;
      try {
        const ipResponse = await axios.get('https://api.ipify.org?format=json');
        ipAddress = ipResponse.data.ip;
      } catch (ipError) {
        console.error('Error fetching IP address:', ipError);
      }

      const userAgent = navigator.userAgent;
      const browser = getBrowser(userAgent);
      const operatingSystem = getOperatingSystem(userAgent);

      const response = await axios.post(apiUrl, {
        type: 'navigation',
        element: `Navigated to ${toPage}`,
        ipAddress: ipAddress,
        browser: browser,
        operatingSystem: operatingSystem,
        userAgent: userAgent,
      });
      console.log('Navigation logged successfully:', response.data);
    } catch (error) {
      console.error('Error logging navigation:', error.message);
    }
  }, []);

  useEffect(() => {
    logPageNavigation(location.pathname);
  }, [location, logPageNavigation]);

  return null;
};

export default TrackNavigation;